import { Link } from "react-router-dom";
import { useConfirmDialog } from "../contexts/ConfirmDialogContext";

interface NotificationCardProps {
  id: string;
  title: string;
  message: string;
  created_at: string | null | undefined;
  importance: "normal" | "important";
  isRead: boolean;
  tripName: string | null | undefined;
  tripId: string | null | undefined;
  author?: {
    first_name: string;
    last_name: string;
  } | null;
  isOrga?: boolean;
  onMarkAsRead?: (id: string) => void;
  onDelete?: (id: string) => void;
}

export default function NotificationCard({
  id,
  title,
  message,
  importance,
  created_at,
  isRead,
  tripName,
  tripId,
  author,
  onMarkAsRead,
  onDelete,
  isOrga,
}: NotificationCardProps) {
  const { showConfirm } = useConfirmDialog();

  return (
    <div
      className={`p-4 border rounded-xl shadow-sm relative mb-3 ${
        isRead
          ? "bg-[#0d1117] border-[#2a3347] text-slate-500"
          : importance === "important"
          ? "bg-red-950/40 border-red-800 text-red-300"
          : "bg-[#161b27] border-[#2a3347]"
      }`}
    >
      <div className="flex justify-between items-start gap-4">
        <div className="flex-1 pr-4">
          <p className="text-sm text-slate-400 mb-1">
            Reise:{" "}
            {tripId ? (
              <Link
                to={`/trip/${tripId}`}
                className="text-sky-400 hover:underline"
              >
                {tripName ?? "Unbekannt"}
              </Link>
            ) : (
              <span className="text-slate-300">{tripName ?? "Unbekannt"}</span>
            )}
            &nbsp;|&nbsp; Verfasst von:{" "}
            <span className="font-medium text-slate-300">
              {author?.first_name} {author?.last_name}
            </span>
          </p>
          <h2 className={`text-lg font-semibold ${isRead ? "text-slate-500" : importance === "important" ? "text-red-200" : "text-slate-100"}`}>
            {importance === "important" && "❗ "}
            {title}
          </h2>
          <p className={`text-sm whitespace-pre-wrap ${isRead ? "text-slate-500" : importance === "important" ? "text-red-300" : "text-slate-300"}`}>{message}</p>
          <p className="text-xs mt-1 text-slate-500">
            {new Date(created_at ?? "").toLocaleString()}
          </p>
        </div>

        <div className="flex flex-col items-end gap-1">
          {!isRead && onMarkAsRead && (
            <button
              onClick={() => onMarkAsRead(id)}
              className="text-sm text-emerald-400 hover:underline"
            >
              Als gelesen
            </button>
          )}

          {isOrga && onDelete && (
            <button
              onClick={async () => {
                const confirmed = await showConfirm({
                  title: "Nachricht löschen",
                  message:
                    "❌ Diese Nachricht wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
                  confirmLabel: "Löschen",
                  cancelLabel: "Abbrechen",
                  icon: "warning",
                });

                if (confirmed) {
                  onDelete(id);
                }
              }}
              className="text-sm text-red-400 hover:underline"
            >
              Löschen
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
